import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ClickstreamFacade from '../../../facades/clickstream-facade';
import { Level } from '@unified-client/event-formatter';

import getFormattedCurrency from '../../../utils/currency-format';
// import OddsFormatUtils from '../../../utils/odds-format-utils';
import { getLogDataFromUserContext } from './../../../services/clickstream-service/utils';


class TestPageOddsFormat extends React.Component {

  state = {
    oddsToConvert: null,
    amount: '',
    currency: '',
    market: '',
    directClickstreamEvent: '',
    GTMClickstreamEvent: '',
  };

  onOddsInputBlur = (event) => {
    this.setState({ oddsToConvert: event.target.value });
  };
  handleAmountInputChange = (event) => {
    this.setState({ amount: event.target.value });
  };
  handleMarketInputChange = (event) => {
    this.setState({ market: event.target.value });
  };
  handleCurrencyInputChange = (event) => {
    this.setState({ currency: event.target.value });
  };
  onDirectClickstreamInputBlur = (event) => {
    this.setState({ directClickstreamEvent: event.target.value });
  };
  sendDirectToClickstream = () => {
    const { directClickstreamEvent } = this.state;
    if (directClickstreamEvent) {
      const logData = getLogDataFromUserContext(this.props.userContext);
      ClickstreamFacade.sendEventToClickstream(JSON.parse(directClickstreamEvent), Level.information, logData);
    }
  };
  onGTMClickstreamInputBlur = (event) => {
    this.setState({ GTMClickstreamEvent: event.target.value });
  };


  render() {
    const { oddsFormat } = this.props.userContext;
    const { oddsToConvert, amount, currency, market } = this.state;
    const formattedCurrency = getFormattedCurrency(amount, market, currency);
    // TODO[EV] odds formatting mechanism has changed - getFormattedOdds() func needs an entire outcome as a param - adapt this if needed
    // const convertedOdds = OddsFormatUtils.getFormattedOdds(oddsFormat, oddsToConvert);

    return (
      <div className="sport-client-test-page-container">
        <h3 className="test-page-title">Test page - odds format & currency format</h3>

        <h4 className="test-page-subtitle">Current odds format: <span className="odds-format">{oddsFormat}</span></h4>
        <div className="odds-area">
          <div>
            <p>Odds to be formatted: <input type="text" onBlur={this.onOddsInputBlur}/></p>
            Converted odds: <code>{oddsToConvert}</code>
          </div>
        </div>


        <h4 className="test-page-subtitle">Test currency format</h4>
        <div className="odds-area">
          <div>
            <form name="currencyForm">
              <p>Amount (required): <input type="text" name="amount" onChange={this.handleAmountInputChange}/></p>
              <p>Currency (required): <input type="text" name="currency" onChange={this.handleCurrencyInputChange}/></p>
              <p>Market (optional): <input type="text" name="market" onChange={this.handleMarketInputChange}/></p>
            </form>
          </div>
          Converted currency: {formattedCurrency ? formattedCurrency : '***'}
        </div>

        <h4 className="test-page-subtitle">Test clickstream server-side mechanism</h4>
        <div className="odds-area">
          <div>
            <p>Event info (JSON): <input type="text" onBlur={this.onDirectClickstreamInputBlur}/></p>
            <button className="test-button" onClick={this.sendDirectToClickstream}> Send to Clickstream</button>
          </div>
        </div>

        <h4 className="test-page-subtitle">Test clickstream mechanism via GTM</h4>
        <div className="odds-area">
          <div>
            <p>Event info (string): <input type="text" onBlur={this.onGTMClickstreamInputBlur}/></p>
            <button className="test-button"> Send to Clickstream via GTM</button>
          </div>
        </div>

      </div>
    );
  }
}

TestPageOddsFormat.propTypes = {
  userContext: PropTypes.object,
  state: PropTypes.object
};

function mapStateToProps(state) {
  const { userContext } = state;
  return { userContext };
}

export default connect(mapStateToProps)(TestPageOddsFormat);
